import { createContext, useContext, useMemo, useState } from "react";
import { QuoteModal } from "../components/site/QuoteModal";
import { SpecModal } from "../components/site/SpecModal";

const Ctx = createContext(null);

export function QuoteProvider({ children }) {
  const [quote, setQuote] = useState(null);
  const [spec, setSpec] = useState(null);
  const value = useMemo(() => ({ openQuote: (opts = {}) => setQuote(opts), openSpecs: (product) => setSpec(product) }), []);
  const specToQuote = (product) => { setSpec(null); setQuote({ product, source: "spec-modal" }); };
  return (
    <Ctx.Provider value={value}>
      {children}
      {quote && <QuoteModal {...quote} close={() => setQuote(null)} />}
      {spec && <SpecModal product={spec} close={() => setSpec(null)} onQuote={specToQuote} onSwitch={setSpec} />}
    </Ctx.Provider>
  );
}

export const useQuote = () => useContext(Ctx);
